export enum AuthProvidersActionTypes {
  ADD_SUCCESS = 'auth-provider/ADD_SUCCESS',
  ADD_ERROR = 'auth-provider/ADD_ERROR',
  ADD_REQUEST = 'auth-provider/ADD_REQUEST',
  DELETE_SUCCESS = 'auth-provider/DELETE_SUCCESS',
  DELETE_REQUEST = 'auth-provider/DELETE_REQUEST',
  DELETE_ERROR = 'auth-provider/DELETE_ERROR',
}
